import React from 'react'
// import { useNavigate } from "react-router-dom";
import { motion } from "framer-motion";
import Client1 from '../../assets/images/sattva_clients/1.png';
import Client2 from '../../assets/images/sattva_clients/2.png';
import Client3 from '../../assets/images/sattva_clients/3.png';
import Client4 from '../../assets/images/sattva_clients/4.png';
import Client5 from '../../assets/images/sattva_clients/5.png';
import Client6 from '../../assets/images/sattva_clients/6.png';
import Client7 from '../../assets/images/sattva_clients/7.png';
import Client8 from '../../assets/images/sattva_clients/8.png';
import Client9 from '../../assets/images/sattva_clients/9.png';
import Client10 from '../../assets/images/sattva_clients/10.png';
import Client11 from '../../assets/images/sattva_clients/11.png';
import { Link } from "react-router-dom";
import backgroundImage from "../../assets/images/bg/bg4.png";
import About1 from "../../assets/images/home-page/banner-desktop.png";
import About2 from "../../assets/images/home-page/banner-phone.png";

export default function Hero() {

  const logos = [Client1, Client2, Client4, Client3, Client5, Client6, Client7, Client8, Client9, Client10, Client11];
  return (
    <section
      style={{ backgroundImage: `url(${backgroundImage})` }}
      className="pt-36 pb-18 md:h-screen h-auto items-center flex relative bg-bottom bg-cover active" id="home">

      <div className="absolute inset-0 -z-1 bg-gradient-to-b from-green-600/20 dark:from-green-600/40 via-green-600/10 dark:via-green-600/20 to-transparent"></div>

      <div className="container relative">
        <div className="grid md:grid-cols-12 grid-cols-1 justify-center items-center gap-16">

          <div className="lg:col-span-6 md:col-span-6 mt-2 md:mt-20">

            <h4 className="lg:text-5xl text-4xl lg:leading-normal leading-normal font-medium mb-4 position-relative dark:text-white">Your all-in-one  <br /> ESG management platform.</h4>

            <p className="text-slate-500 dark:text-white/70 mb-0 max-w-2xl text-lg">Enter a new phase of ESG management with SATTVA, a SaaS platform designed to help organizations manage ESG standards with clarity, consistency, and control.</p>
            <div className="subcribe-form mt-6">
              <div className="subcribe-form mt-6">
                <Link to="/contact">
                  <button
                    type="button"
                    className="group relative inline-flex items-center gap-3 
             bg-gradient-to-r from-blue-600 to-indigo-400 
             hover:from-indigo-600 hover:to-blue-400
             text-white font-semibold text-lg
             px-8 py-3 rounded-full
             shadow-lg hover:shadow-2xl
             transition-all duration-300 ease-in-out
             transform hover:-translate-y-1 hover:scale-105
             focus:outline-none focus:ring-4 focus:ring-blue-300/40"
                  >
                    <span>Book a Demo</span>
                    <i className="uil uil-arrow-right transition-transform duration-300 group-hover:translate-x-1"></i>
                  </button>
                </Link>
              </div>
            </div>

          </div>

          <div className="lg:col-span-6 md:col-span-6">
            <div className="relative">
              <div className="relative flex justify-end">
                <motion.img
                  src={About1}
                  className="lg:w-[600px] w-[480px] rounded-xl"
                  alt=""
                  initial={{ opacity: 0, y: 50 }}   // start invisible & lower
                  animate={{ opacity: 1, y: 0 }}     // animate to visible & original position
                  transition={{ duration: 1, ease: "easeOut" }} // animation duration & easing
                />
                {/* Optional YouTube play button */}
              </div>
              <div className="absolute md:-start-10 start-0 -bottom-10">
                <motion.img
                  src={About2}
                  className="lg:w-[140px] w-[70px] dark:border-slate-900 rounded-xl"
                  alt=""
                  initial={{ opacity: 0, y: 30 }}
                  animate={{ opacity: 1, y: 0 }}
                  transition={{ duration: 1, delay: 0.3, ease: "easeOut" }}
                />
              </div>
            </div>
          </div>
        </div>
        <div className="relative w-full overflow-hidden py-6">
          <div className="marquee-track flex w-max">
            {[...logos, ...logos].map((logo, index) => (
              <div
                key={index}
                className="
          flex-shrink-0
          h-16 md:h-36 lg:h-36
          w-40 md:w-42
          flex items-center justify-center
          transition-all duration-300
          opacity-90
          hover:opacity-100
          hover:scale-105
          dark:opacity-60
          dark:hover:opacity-100
        "
              >
                <img
                  src={logo}
                  alt={`logo-${index}`}
                  className="h-full object-contain dark:brightness-0 dark:invert"
                />
              </div>
            ))}
          </div>

          {/* Animation */}
          <style jsx>{`
    .marquee-track {
      animation: marquee 30s linear infinite;
    }

    @keyframes marquee {
      from {
        transform: translateX(0);
      }
      to {
        transform: translateX(-50%);
      }
    }
  `}</style>
        </div>



      </div>
    </section>
  )
}
